/**
 * @module events/types/beforeToggle
 */

/**
 * @type {string}
 */
export default 'beforetoggle'
